import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SkeletonModule } from "primeng/skeleton";

/**
 * Componente skeleton per la pagina Admin Impersonate
 * Mostra skeleton mentre i dati sono in caricamento
 * Include sidenav laterale e tabella principale
 */
@Component({
  selector: "ape-admin-impersonate-skeleton",
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: "./ape-admin-impersonate-skeleton.component.html"
})
export class ApeAdminImpersonateSkeletonComponent {}